import * as React from 'react'

import { colors } from '@factorialco/deprecated-design-system'

const Circle: React.FC = () => {
  return (
    <svg height={10} width="100%">
      <circle style={{ fill: colors.grey400 }} cx="50%" cy="5" r="5" />
    </svg>
  )
}

export default Circle
